import { GetBillingPaymentResponseType } from '@frontend/sorghum/interface';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { BILLING_PAYMENT } from '../apis';

const defaultData = {
  planDetail: {
    plan: 1,
    period: 1,
  },
  paymentDetail: {
    method: 1,
    lastFour: '',
  },
  invoiceDetail: {
    type: 1,
  },
};

async function getGetBillingPayment(
  type: number,
  projectID: string,
): Promise<GetBillingPaymentResponseType> {
  return (
    axios
      // 明確帶上 query key 的專案，避免 sessionStorage 殘留別的專案時拿錯付款資料
      .get(`${BILLING_PAYMENT}?type=${type}`, {
        headers: { 'project-id': projectID },
      })
      .then((res) => res.data.data)
      .catch((err) => {
        return defaultData;
      })
  );
}

export function useGetBillingPayment(type: number, projectID?: string) {
  return useQuery<GetBillingPaymentResponseType>({
    queryKey: ['get-billing-payment', { type, projectID }],
    queryFn: () => {
      if (projectID) {
        return getGetBillingPayment(type, projectID);
      } else {
        return defaultData;
      }
    },
  });
}

export default useGetBillingPayment;
